"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Select;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SelectModule = _interopRequireDefault(require("./Select.module.scss"));

var _getSelectStyle = _interopRequireDefault(require("./getSelectStyle"));

var _excluded = ["width", "height", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Select(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? "128px" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "16px" : _ref$height,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "DEFAULT" : _ref$type,
      args = _objectWithoutProperties(_ref, _excluded);

  /* eslint-disable react/jsx-props-no-spreading */
  return /*#__PURE__*/_react.default.createElement(_reactSelect.default, _extends({
    isSearchable: false,
    classNamePrefix: "fhx-select"
  }, args, {
    styles: (0, _getSelectStyle.default)(width, height),
    className: (0, _classnames.default)(_SelectModule.default.select, _SelectModule.default[type], args.className)
  }));
}